export enum AppSectionIconTheme {
  DEFAULT = 'default',
  NIGHT = 'night',
  ERROR = 'error'
}
